import { AvtaleGiroActionType } from './actions';
import { avtalegiroInitialState } from './state';
const avtalegiroReducer = (state, action) => {
    switch (action.type) {
        case AvtaleGiroActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case AvtaleGiroActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case AvtaleGiroActionType.SET_KID:
            return {
                ...state,
                kid: action.payload,
            };
        case AvtaleGiroActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case AvtaleGiroActionType.TRANSACTION_AMOUNT_LIMIT:
            return {
                ...state,
                transactionLimit: action.payload,
            };
        case AvtaleGiroActionType.MONTHLY_AMOUNT_LIMIT:
            return {
                ...state,
                monthlyLimit: action.payload ?? 0,
            };
        case AvtaleGiroActionType.RESET:
            return {
                ...avtalegiroInitialState,
            };
        case AvtaleGiroActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case AvtaleGiroActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        default:
            return state;
    }
};
export default avtalegiroReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVkdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3RyYW5zYWN0aW9uL0F2dGFsZUdpcm8vZm9ybS9yZWR1Y2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBb0Isb0JBQW9CLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFDbkUsT0FBTyxFQUFFLHNCQUFzQixFQUFtQixNQUFNLFNBQVMsQ0FBQztBQUVsRSxNQUFNLGlCQUFpQixHQUFHLENBQUMsS0FBc0IsRUFBRSxNQUF3QixFQUFtQixFQUFFO0lBQzVGLFFBQVEsTUFBTSxDQUFDLElBQUksRUFBRSxDQUFDO1FBQ2xCLEtBQUssb0JBQW9CLENBQUMscUJBQXFCO1lBQzNDLE9BQU87Z0JBQ0gsR0FBRyxLQUFLO2dCQUNSLFdBQVcsRUFBRSxNQUFNLENBQUMsT0FBTzthQUM5QixDQUFDO1FBQ04sS0FBSyxvQkFBb0IsQ0FBQyxtQkFBbUI7WUFDekMsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1IsU0FBUyxFQUFFLE1BQU0sQ0FBQyxPQUFPO2FBQzVCLENBQUM7UUFDTixLQUFLLG9CQUFvQixDQUFDLE9BQU87WUFDN0IsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1IsR0FBRyxFQUFFLE1BQU0sQ0FBQyxPQUFPO2FBQ3RCLENBQUM7UUFDTixLQUFLLG9CQUFvQixDQUFDLElBQUk7WUFDMUIsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1IsSUFBSSxFQUFFLE1BQU0sQ0FBQyxPQUFPO2FBQ3ZCLENBQUM7UUFDTixLQUFLLG9CQUFvQixDQUFDLHdCQUF3QjtZQUM5QyxPQUFPO2dCQUNILEdBQUcsS0FBSztnQkFDUixnQkFBZ0IsRUFBRSxNQUFNLENBQUMsT0FBTzthQUNuQyxDQUFDO1FBQ04sS0FBSyxvQkFBb0IsQ0FBQyxvQkFBb0I7WUFDMUMsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1IsWUFBWSxFQUFFLE1BQU0sQ0FBQyxPQUFPLElBQUksQ0FBQzthQUNwQyxDQUFDO1FBQ04sS0FBSyxvQkFBb0IsQ0FBQyxLQUFLO1lBQzNCLE9BQU87Z0JBQ0gsR0FBRyxzQkFBc0I7YUFDNUIsQ0FBQztRQUNOLEtBQUssb0JBQW9CLENBQUMsa0JBQWtCO1lBQ3hDLE9BQU87Z0JBQ0gsR0FBRyxLQUFLO2dCQUNSLGdCQUFnQixFQUFFLElBQUk7YUFDekIsQ0FBQztRQUNOLEtBQUssb0JBQW9CLENBQUMsa0JBQWtCO1lBQ3hDLE9BQU87Z0JBQ0gsR0FBRyxLQUFLO2dCQUNSLGdCQUFnQixFQUFFLEtBQUs7YUFDMUIsQ0FBQztRQUNOO1lBQ0ksT0FBTyxLQUFLLENBQUM7SUFDckIsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLGVBQWUsaUJBQWlCLENBQUMifQ==